export const projectData = [
    {
        displayName: "Socializer",
        technology: ["HTML5", "CSS3", "ReactJS", "Redux"],
        description:
            "Socializer is a social media app that makes it easy to connect with people and share posts among friends.",
        features:
            "It has authentication, post-management, debounced-based Search user field, replies/comments, profile management, follow/unfollow, and like a post.",
        photoUrl: "https://i.imgur.com/4gVHxkM.jpg",
        url: "https://social-media-123.netlify.app",
    },
    {
        displayName: "BookStore",
        technology: ["HTML5", "CSS3", "ReactJS"],
        description: "An e-commerce library for finding books.",
        features:
            "It has authentication, Cart Management, Wishlist management, sort & filter, and debounced-based search functionality.",
        photoUrl: "https://i.imgur.com/3oICi1C.jpg",
        url: "https://bookstore-react-123.netlify.app/",
    },
    {
        displayName: "Quiz App",
        technology: ["HTML5", "CSS3", "ReactJS", "Firebase"],
        description:
            "Quizzy is a simple MCQ-based quiz app to test your programming knowledge.",
        features:
            "It has functionality like filtering quizzes by category, giving objective quizzes, and a result page with right/wrong answers.",
        photoUrl: "https://i.imgur.com/6rBZUs5.jpg",
        url: "https://quizzy-react-123.netlify.app/",
    },
    {
        displayName: "GameHub",
        technology: ["HTML5", "CSS3", "ReactJS"],
        description: "A Video library for watching gaming videos.",
        features:
            "It has functionality like filtering video, playlist management, like video, watches later, and history management.",
        photoUrl: "https://i.imgur.com/Qkn5dOe.jpg",
        url: "https://gamehub123.netlify.app/",
    },
    {
        displayName: "FastUI",
        technology: ["HTML5", "CSS3"],
        description:
            "Fast UI provides a user-friendly, free, and reusable component to use in the UI of a website.",
        features:
            "It provides many components like typography, buttons, avatar, alert, modal, and many more with documentation and example on how to use it.",
        photoUrl: "https://i.imgur.com/DeqI4i2.jpg",
        url: "https://fastui.netlify.app/",
    },
];
